module.exports = __webpack_public_path__ + "static/index/img/baikal-203.2f4874a0.jpg";